export const MANAGEMENT_TYPES = {
  CHANGE_PERCENT_RATE: 'change-percent-rate',
  GET_RATES_CSV: 'get-rates-csv',
};
